import { useSelector } from 'react-redux'
import MaternityForm from '../MaternityDetail/MaternityForm'
import { RootState } from '../../redux-store'
import styled from '@emotion/styled'
import Breadcrumb from '../../components/common/Breadcrumb'
import MaternityInfo from '../MaternityDetail/MaternityInfo'
import { useRouter } from '../../utils/helper'
import { useGetMaternityById } from '../../services/maternity/maternity-query'
import { home } from '../../constant/path'
import { pullAt } from 'lodash'
import { useScreen } from '../../utils/responsive-helper'
import Headbar from '../../components/common/HeadBar'
import { maternityDetail } from '../../constant/path'
import { useTranslation } from 'react-i18next'
import { mobile } from '../../utils/responsive-helper'
import { MaternityInfoWithConcentDate, MaternityInfoWithoutConcentDate } from '../../redux-store/maternity-reducer'
import color from '../../constant/colors'

const BackgroundHeader = styled.div`
  background-color: ${color.CHOICES_PRIMARY};
  width: calc(100% - 32px);
  height: 266px;
  margin-top: 0px !important;
  position: absolute;

  ${mobile} {
    width: 100%;
  }
`
const Layout = styled.div`
  width: 768px;
  margin: 0 auto;
  z-index: 1;
  > * {
    margin-top: 24px;
  }

  ${mobile} {
    width: 100%;
  }
`

const MaternitySummary = () => {
  const { query } = useRouter<{ maternityId: number }>()
  const { t } = useTranslation()
  const { isMobile } = useScreen()
  const { data: maternityItem } = useGetMaternityById({ claimId: query.maternityId })

  const maternityFormValue = useSelector((state: RootState) => state.maternity.claimInfo) as MaternityInfoWithConcentDate & MaternityInfoWithoutConcentDate

  return (
    <>
      <BackgroundHeader />
      <Layout>
        <Headbar title={maternityItem?.name || ''} backWard={maternityDetail({ routeParam: { maternityId: query.maternityId } })} />
        {/* <MaternityInfo maternityItem={maternityItem} editable={false} /> */}
        <MaternityForm
          maternityItem={maternityItem}
          maternityId={query.maternityId}
          maternityFormValue={maternityFormValue}
          editable={false}
          isPreview={true}
        />
      </Layout>
    </>
  )
}

export default MaternitySummary
